<i
	aria-hidden="true"
	aria-roledescription="button"
	matTooltipClass="pv-tooltip"
	matTooltipPosition="right"
	role="button"
	[class]="iconClass"
	[matTooltip]="help"
	[matTooltipDisabled]="!help"
	[matTooltipShowDelay]="500"
	(click)="onClick($event)"
>
	<ng-content />
</i>
